module.exports = __webpack_public_path__ + "img/icon-email.5e40933a.svg";